<script setup>
import { useSidebar } from '@/shadcn/components/ui/sidebar'
import { useRoutePage } from '@/hooks/use-route-page.js'

const { open } = useSidebar()
const { isDashboardOrSettingsPage } = useRoutePage()

</script>

<template>
  <div
    id="kt_header"
    class="header header-fixed page-header tw-z-[98] tw-transition-[right] tw-duration-200"
    :class="{'!tw-right-[--sidebar-width]': open && isDashboardOrSettingsPage}"
  >
    <slot></slot>
  </div>
</template>
